<template>
  <div class="morefuture-base">
    <div class="line-top">
      <svg
        :width="upperLine.width"
        :height="upperLine.height"
        :viewBox="`0, 0, ${upperLine.width}, ${upperLine.height}`"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          v-for="(par, index) in upperLine.list"
          :key="index"
          :cx="par.cx"
          :cy="par.cy"
          :r="par.r"
          :fill="par.fill" />
      </svg>
    </div>

    <h4><img src="/static/img/yearluck/y2020/morefuture.svg"></h4>
    <div class="message">{{ moreFutureWordsMod }}</div>

    <div class="line-bottom">
      <svg
        :width="lowerLine.width"
        :height="lowerLine.height"
        :viewBox="`0, 0, ${lowerLine.width}, ${lowerLine.height}`"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          v-for="(par, index) in lowerLine.list"
          :key="index"
          :cx="par.cx"
          :cy="par.cy"
          :r="par.r"
          :fill="par.fill" />
      </svg>
    </div>
  </div>
</template>

<script>
import Colors from '@/utvStore/components/YearLuck/y2020/constants/colors'

const LINE_PARTICLE_SIZE = 3

export default {
  name: "MoreFuture",
  props: {
    moreFutureWords: {
      type: String,
      default() {
        return ''
      }
    },
    targetId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      upperLine: {
        list: [],
        width: 0,
        height: 0,
      },
      lowerLine: {
        list: [],
        width: 0,
        height: 0,
      }
    }
  },
  mounted() {
    this.calc()
  },
  computed: {
    moreFutureWordsMod() {
      let rtn = this.moreFutureWords
      if(rtn.length === 2) rtn = `${rtn.substr(0,1)} ${rtn.substr(1,1)}`
      return rtn
    }
  },
  methods: {
    calc() {
      const bw = this.$el.clientWidth
      let sep, tw, w, scl, flg

      w = LINE_PARTICLE_SIZE
      sep = parseInt(bw/w) - 1
      sep = sep/2 > 0 ? sep : sep - 1
      tw = w * sep + w
      scl = bw / tw
      flg = false

      for(let i = 0; i < sep; i++ ){
        if((i % 2) > 0) {
          let fill_u = Colors.color.basecolor
          let fill_l = Colors.color.basecolor
          if(flg) {
            const collist = Colors.getItemColor(this.targetId)
            if( collist != null ) {
              fill_u = collist[Math.floor(Math.random() * collist.length)]
              fill_l = collist[Math.floor(Math.random() * collist.length)]
            }
            flg = false
          }else {
            flg = true
          }

          this.upperLine.width = bw
          this.upperLine.height = Math.ceil(w / scl)
          this.upperLine.list.push({
            cx: (i * w * scl) + (w / 2),
            cy: w / 2,
            r: w * scl / 2,
            fill: fill_u
          })

          this.lowerLine.width = bw
          this.lowerLine.height = Math.ceil(w / scl)
          this.lowerLine.list.push({
            cx: (i * w * scl) + (w / 2),
            cy: w / 2,
            r: w * scl / 2,
            fill: fill_l
          })
        }
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/variables/index";
.morefuture-base {
  width: 100%;
  color: $gray-20;
  margin-bottom: 10px;
  h4 {
    line-height: 1;
    width: 100%;
    margin: 0 0 15px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    letter-spacing: 1px;
    padding: 18px 0 12px;
    position: relative;
    &:after {
      content: '';
      width: 17px;
      height: 2px;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      display: block;
      position: absolute;
      background: $brown-10;
    }
  }
  .message {
    width: 100%;
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    padding: 0 8px 18px;
  }
  .line-top,
  .line-bottom {
    width: 100%;
    height: 4px;
    svg {
      display: block;
      vertical-align: top;
    }
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/moreFuture.vue